import type {SearchField, QueryToken} from './types';

const translations = {
	assetsFieldName: {
		id: 'search.assets.name',
		defaultValue: 'Name'
	},
	assetsFieldURN: {
		id: 'search.assets.urn',
		defaultValue: 'URN'
	},
	assetGroupsFieldName: {
		id: 'search.assetsGroups.name',
		defaultValue: 'Name'
	},
	assetGroupsFieldDisplayName: {
		id: 'search.assetsGroups.displayName',
		defaultValue: 'Display Name'
	},
	userGroupsFieldName: {
		id: 'search.userGroups.name',
		defaultValue: 'Name'
	}
};

export const assetFields: Array<SearchField> = [
	{
		key: 'name',
		label: translations.assetsFieldName,
		type: 'STRING'
	},
	{
		key: 'urn',
		label: translations.assetsFieldURN,
		type: 'STRING'
	}
];

export const assetGroupFields: Array<SearchField> = [
	{
		key: 'name',
		label: translations.assetGroupsFieldName,
		type: 'STRING'
	},
	{
		key: 'displayName',
		label: translations.assetGroupsFieldDisplayName,
		type: 'STRING'
	}
];

export const userGroupFields: Array<SearchField> = [
	{
		key: 'name',
		label: translations.userGroupsFieldName,
		type: 'STRING'
	}
];

export const completeFieldQuery = (query: string, field: SearchField): string => {
	return query.replace(/(\w+)$/, `${field.key}:`);
};
const EMPTY_ARRAY: Array<SearchField> = [];
export const getMatchingFields = (
	query: string,
	queryTokens: Array<QueryToken> | null | undefined,
	fields: Array<SearchField>
): Array<SearchField> => {
	const match = query.match(/(\w+)$/);
	let matchingFields = EMPTY_ARRAY;

	if (match && queryTokens && queryTokens.length && !queryTokens[queryTokens.length - 1].field) {
		matchingFields = fields.filter((f) => f.key.startsWith(match[1]));
	}

	return matchingFields;
};
